{
  "title": "autobrr",
  "username": "Usuario",
  "password": "Contraseña",
  "confirmPassword": "Confirmar contraseña",
  "createAccount": "Crear cuenta",
  "rememberMe": "Recordarme",
  "forgotPassword": "¿Olvidaste tu contraseña?",
  "forgotPasswordHelp": "Restablecer vía terminal:",
  "signIn": "Iniciar sesión",
  "continueWith": "O continuar con",
  "openidConnect": "OpenID Connect",
  "errors": {
    "required": "Obligatorio",
    "usernameRequired": "El usuario es obligatorio",
    "passwordRequired": "La contraseña es obligatoria",
    "passwordsDoNotMatch": "¡Las contraseñas no coinciden!",
    "generic": "¡Ocurrió un error!",
    "oidcFailed": "La autenticación OIDC falló"
  }
}
